"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var view_icon_svg_1 = __importDefault(require("res/img/view-icon.svg"));
var OrdersTableRow = function (_a) {
    var data = _a.data;
    return (react_1.default.createElement("div", { className: 'table-row flex flex-row' },
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.altOrderNumber !== "" && data.altOrderNumber !== null ? data.altOrderNumber : data.orderNumber)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.orderDate)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null,
                data.firstName,
                " ",
                data.lastName)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.status)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null, data.orderItems.length)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null,
                data.currency === 'priceAlt' ? "€" : "£",
                data.itemTotal)),
        react_1.default.createElement("div", { className: 'table-row__td' },
            react_1.default.createElement("span", null,
                data.currency === 'priceAlt' ? "€" : "£",
                data.partialRefundValue !== null ? (parseFloat(data.orderTotal) - parseFloat(data.partialRefundValue)).toFixed(2) : data.orderTotal)),
        react_1.default.createElement("div", { className: 'table-row__td flex flex-row' },
            react_1.default.createElement(react_router_dom_1.Link, { to: "/orders/" + data.id, className: 'table-row__action flex flex-column flex-center', title: 'View', "aria-label": 'View Order' },
                react_1.default.createElement("img", { src: view_icon_svg_1.default, alt: 'View' })))));
};
exports.default = OrdersTableRow;
